import CarHireMobileSearchControls from 'components/CarHire/CarHireMobileSearchControls/CarHireMobileSearchControls'
import CarHireSearchBar from 'components/CarHire/CarHireSearchBar/CarHireSearchBar'
import RecentCarHireSearches from 'components/CarHire/RecentCarHireSearches/RecentCarHireSearches'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import useRecentCarHireSearches from 'hooks/CarHire/useRecentCarHireSearches'

function CarsCarHireSearchBar() {
  const recentSearches = useRecentCarHireSearches()

  return (
    <>
      <CSSBreakpoint min="tablet">
        <CarHireSearchBar />
      </CSSBreakpoint>
      <CSSBreakpoint max="mobile">
        <CarHireMobileSearchControls />
      </CSSBreakpoint>
      {recentSearches.length > 0 && <RecentCarHireSearches recentSearches={recentSearches} />}
    </>
  )
}

export default CarsCarHireSearchBar
